import { Component, HostBinding, OnInit } from '@angular/core';
import { AuthService, ScreenService, AppInfoService } from './shared/services';
import { Title }     from '@angular/platform-browser';
import {AppConfigService} from './app-config.service';
import {Configuration} from './app.constants';
declare var google:any; 
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  loginpageshow:string="";
  popupVisibleDoc:boolean=false;
  ngOnInit(){
    //this.loginpageshow=this.Configuration.loginpageshow;
  }
  @HostBinding('class') get getClass() {
    return Object.keys(this.screen.sizes).filter(cl => this.screen.sizes[cl]).join(' ');
  }
  
  constructor(private authService: AuthService, private screen: ScreenService, public appInfo: AppInfoService,private titleService: Title,private appConfigService : AppConfigService,
    public Configuration:Configuration) {
      
    this.setTitle(this.appConfigService.IndexTitle);
   }
   
  isAutorized() {
    return this.authService.isLoggedIn;
  }
  viclick(){
    debugger;
    this.popupVisibleDoc=true;
  }
  public setTitle( newTitle: string) {
    this.titleService.setTitle( newTitle );
  }
}
